import { Button, Box, Text, Bleed, Actions, Stack } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { DialogEventHandler } from '@/types'
import useGetPlanKey from '@/hooks/use-get-plan-key'

type Props = {
  closeModal: DialogEventHandler
  noFlag?: boolean
  onSubmit: () => void
}

const ModalContent = ({ closeModal, noFlag, onSubmit }: Props) => {
  const { t } = useTranslation()
  const planText = useGetPlanKey()
  const dispatch = useDispatch()
  const handleSubmit = () => {
    if (!noFlag) {
      dispatch.session.createFlag({ name: 'skip_syndication_info_modal', value: '1' })
    }
    onSubmit()
    closeModal()
  }
  return (
    <Box>
      <Box background="body" marginBottom="xxxsmall">
        <Stack space="small">
          <Text size="xlarge" weight="medium">
            {t('l.usage.credits.advertise_your_listing.text', 'Advertise your listing')}
          </Text>
          <Text size="medium" weight="regular">
            {t(
              'l.usage.credits.select_a_package_content.text',
              `Get up to 65% more inquiries with Multi-platform Advertising. We'll share your listing to Facebook, Craigslist, and Zumper and manage all inquiries to get your listing rented faster.`
            )}
          </Text>
        </Stack>
      </Box>

      <Bleed horizontal="large" bottom="large">
        <Box background="body" paddingX="large" paddingY="large">
          <Actions align="right">
            <Button
              type="submit"
              variant="solid"
              onClick={handleSubmit}
              size="small"
              id={`usage-credit-${planText}-popup-advertiseyourlisting-get-started-btn-click`}
            >
              {t('b.usage.dialog.get_started.title', 'Get Started')}
            </Button>
          </Actions>
        </Box>
      </Bleed>
    </Box>
  )
}

export default ModalContent
